import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

export async function UploadBlogImage(formData: any){
    const response = await axios.post(`${getEndpoint()}/api/Blog/AddImage`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            "bypass-tunnel-reminder": "true"
        }
    });
    return response;
}

export async function DeleteBlogImage(fileName: any){
    const response = await axios.delete(`${getEndpoint()}/api/Blog/DeleteImage?url=${fileName}`
        ,ngrokSkipWarning)
    //console.log(response.data);
    return response;
}

export async function AddBlog(blog: any){
    const response = await axios.post(`${getEndpoint()}/api/Blog/CreateBlog`, blog,
        ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}


export async function GetAllBlog(){
    const response = await axios.get(`${getEndpoint()}/api/Blog/GetAll`,
        ngrokSkipWarning);
    //console.log(response.data);
    return response.data;
}

export async function DeleteBlog(id: any) {
    try {
      const response = await axios.delete(`${getEndpoint()}/api/Blog/DeleteBlog?id=${id}`, ngrokSkipWarning);
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  }

  export async function UpdateBlog(form:any) {
    const response = await axios.put(`${getEndpoint()}/api/Blog/UpdateBlog`,form , {headers:{
      "Content-Type": "multipart/form-data",
              "bypass-tunnel-reminder": "true"},});
    return response.data;
}